import {
  ChartVolumeAndPriceByTodayParamsTypes,
  ChartVolumeAndPriceByTodayTypes,
  ShortcutChartParamsTypes,
  ShortcutChartDataTypes,
  StockInformationDataTypes,
} from './types';

import axiosInstance from 'services/common/instance';

export const stockInformationDataService = async (
  code: string,
): Promise<StockInformationDataTypes> => {
  const response = await axiosInstance.get(`ttpt-company-indicators/${code}`);
  return response.data.data;
};

export const getChartVolumeAndPriceByToday = async (
  params: ChartVolumeAndPriceByTodayParamsTypes,
): Promise<ChartVolumeAndPriceByTodayTypes[]> => {
  const response = await axiosInstance.get('ttpt-ws-order-matching/chart-volume-and-price-by-today', { params });
  return response.data.data;
};

export const shortcutChartDataService = async (
  params: ShortcutChartParamsTypes,
): Promise<ShortcutChartDataTypes[]> => {
  const response = await axiosInstance.get('ttpt-ws-order-matching/chart-volume-and-price', {
    params,
  });
  return response.data.data;
};

export const placeholder = '';
